define('model/training.model',['require','exports','module','fukit/fukit'],function(require, exports, module) {
  var BaseModel = require('fukit/fukit').BaseModel;

  var TrainingModel = BaseModel.extend({
    radioRequests: {
      'models TrainingModel': '@constructor',
    },

    urlRootTemplate: '/api/v2/person/:personId/training',

    defaults: {
      // this field will be used later by other systems
      // but for now staticlly setting it to "manual"
      // will work for our needs
      dataOrigin: 'manual',
    },
  });
  module.exports = TrainingModel;
});

